import { render, staticRenderFns } from "./casting-notice-detail.vue?vue&type=template&id=51772b78&scoped=true"
import script from "./casting-notice-detail.vue?vue&type=script&lang=js"
export * from "./casting-notice-detail.vue?vue&type=script&lang=js"
import style0 from "./casting-notice-detail.vue?vue&type=style&index=0&id=51772b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51772b78",
  null
  
)

export default component.exports